// @ts-nocheck
(() => {
  const moneyFormat =
    window.themeGlobalVariables?.settings?.money_format ||
    window.cartStrings?.money_format ||
    window.Shopify?.money_format ||
    '${{amount}}';

  const formatMoney = (cents) => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, moneyFormat);
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  };

  const getDrawer = (card) => {
    const drawerId = card?.dataset?.psDrawerId;
    return drawerId ? document.getElementById(drawerId) : null;
  };

  const FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const getFocusable = (root) => [...root.querySelectorAll(FOCUSABLE_SELECTOR)].filter((el) => el.offsetParent !== null);

  // Escape closes the drawer; Tab is trapped within the sheet so keyboard focus
  // can't drift to the page behind the (now aria-modal) dialog.
  const onDrawerKeydown = (event) => {
    const drawer = event.currentTarget;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer(drawer);
      return;
    }
    if (event.key !== 'Tab') return;
    const sheet = drawer.querySelector('.ps-card-drawer__sheet') || drawer;
    const focusable = getFocusable(sheet);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !sheet.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const openDrawer = (drawer) => {
    if (!drawer) return;
    if (drawer.parentElement !== document.body) {
      drawer.classList.add('personalization-steps-block');
      document.body.appendChild(drawer);
    }
    drawer._personalizedUpsellReturnFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.addEventListener('keydown', onDrawerKeydown);
    // Move focus into the dialog so its label is announced and keyboard users
    // land inside it (the sheet carries tabindex="-1" + aria-labelledby).
    const sheet = drawer.querySelector('.ps-card-drawer__sheet') || drawer;
    if (sheet.getAttribute('tabindex') == null) sheet.setAttribute('tabindex', '-1');
    sheet.focus?.();
    requestAnimationFrame(() => {
      drawer.querySelectorAll('[data-ps-gallery]').forEach((gallery) => {
        gallery._personalizedUpsellSyncGallery?.();
      });
      const idInput = drawer.querySelector('[data-ps-card-variant-id-input]');
      if (idInput?.value) {
        document.dispatchEvent(
          new CustomEvent('variant:changed', {
            detail: { variant: { id: idInput.value }, productFormId: idInput.closest('[id]')?.id },
          }),
        );
      }
    });
  };

  const closeDrawer = (drawer) => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.removeEventListener('keydown', onDrawerKeydown);
    const returnTo = drawer._personalizedUpsellReturnFocus;
    drawer._personalizedUpsellReturnFocus = null;
    if (returnTo && typeof returnTo.focus === 'function' && document.contains(returnTo)) returnTo.focus();
  };

  const validateDrawer = (card, drawer) => {
    const containerId = card.dataset.psCardFormId;
    const container = containerId ? document.getElementById(containerId) : drawer;
    const invalid = container
      ? [...container.querySelectorAll('input, select, textarea')].find(
          (el) => !el.disabled && typeof el.checkValidity === 'function' && !el.checkValidity(),
        )
      : null;
    if (invalid) {
      invalid.reportValidity();
      return false;
    }
    return true;
  };

  const wireVariantOptions = (card, drawer) => {
    const variantContainer = drawer.querySelector('[data-ps-card-variants]');
    if (!variantContainer || variantContainer.dataset.personalizedUpsellWired === 'true') return;
    variantContainer.dataset.personalizedUpsellWired = 'true';

    const mapScript = variantContainer.querySelector('[data-ps-card-variant-map]');
    if (!mapScript) return;

    let variantMap = {};
    try {
      variantMap = JSON.parse(mapScript.textContent || '{}');
    } catch (error) {
      return;
    }

    const hiddenIdInput = drawer.querySelector('[data-ps-card-variant-id-input]');
    const priceEl = card.querySelector('[data-personalized-upsell-price], .ps-upsell-pr');
    const drawerPriceCurrent = drawer.querySelector('[data-ps-card-price-current]');
    const drawerPriceCompare = drawer.querySelector('[data-ps-card-price-compare]');

    const readSelectedOptions = () => {
      const selected = {};
      variantContainer.querySelectorAll('input[type="radio"][data-ps-card-option-index]').forEach((input) => {
        if (input.checked) selected[input.dataset.psCardOptionIndex] = input.value;
      });
      return Object.keys(selected)
        .map((key) => parseInt(key, 10))
        .sort((a, b) => a - b)
        .map((key) => selected[key])
        .join('|');
    };

    const applySelectedVariant = () => {
      const variant = variantMap[readSelectedOptions()];
      if (!variant) return;

      card.dataset.upsellVariantId = String(variant.id);
      card.dataset.upsellPrice = String(variant.price);
      if (priceEl) priceEl.textContent = '+' + formatMoney(variant.price);
      if (hiddenIdInput) {
        hiddenIdInput.value = String(variant.id);
        hiddenIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (drawerPriceCurrent) drawerPriceCurrent.textContent = formatMoney(variant.price);
      if (drawerPriceCompare) {
        const hasCompare = variant.compare_at_price != null && variant.compare_at_price > variant.price;
        drawerPriceCompare.textContent = hasCompare ? formatMoney(variant.compare_at_price) : '';
        drawerPriceCompare.hidden = !hasCompare;
      }

      document.dispatchEvent(
        new CustomEvent('variant:changed', {
          detail: { variant: { id: variant.id }, productFormId: hiddenIdInput?.closest('[id]')?.id },
        }),
      );

      updateSelectedPriceDelta();
    };

    variantContainer.querySelectorAll('input[type="radio"][data-ps-card-option-index]').forEach((input) => {
      input.addEventListener('change', applySelectedVariant);
    });

    applySelectedVariant();
  };

  const wireGallery = (gallery) => {
    if (!gallery || gallery.dataset.personalizedUpsellGalleryWired === 'true') return;
    gallery.dataset.personalizedUpsellGalleryWired = 'true';

    const wrapper = gallery.querySelector('.swiper-main .swiper-wrapper');
    const slides = wrapper ? [...wrapper.querySelectorAll('.swiper-slide')] : [];
    const thumbs = [...gallery.querySelectorAll('[data-ps-gallery-thumb]')];
    if (!wrapper || thumbs.length <= 1) return;

    wrapper.querySelectorAll('img').forEach((img) => {
      img.draggable = false;
    });

    let activeIndex = 0;
    const clampIndex = (index) => Math.max(0, Math.min(thumbs.length - 1, index));
    const syncTo = (index, options = {}) => {
      activeIndex = clampIndex(index);
      slides.forEach((slide, i) => {
        slide.classList.toggle('swiper-slide-active', i === activeIndex);
      });
      thumbs.forEach((thumb, i) => {
        const isActive = i === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
          if (options.scrollThumb !== false) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    };
    const slideTo = (index, speed = 300) => {
      const nextIndex = clampIndex(index);
      syncTo(nextIndex);
      const slide = slides[nextIndex];
      if (slide) {
        wrapper.scrollTo({
          left: slide.offsetLeft - wrapper.offsetLeft,
          behavior: speed === 0 ? 'auto' : 'smooth',
        });
      }
    };
    const getClosestIndex = () => {
      const wrapperLeft = wrapper.getBoundingClientRect().left;
      return slides.reduce(
        (closest, slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - wrapperLeft);
          return distance < closest.distance ? { index, distance } : closest;
        },
        { index: activeIndex, distance: Infinity },
      ).index;
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        slideTo(parseInt(thumb.dataset.index || '0', 10));
      });
    });

    let scrollSyncFrame = null;
    wrapper.addEventListener(
      'scroll',
      () => {
        if (scrollSyncFrame) cancelAnimationFrame(scrollSyncFrame);
        scrollSyncFrame = requestAnimationFrame(() => syncTo(getClosestIndex(), { scrollThumb: false }));
      },
      { passive: true },
    );

    let dragStartX = 0;
    let dragStartScrollLeft = 0;
    let isDragging = false;
    let hasDragged = false;
    let suppressClickUntil = 0;

    wrapper.addEventListener('pointerdown', (event) => {
      if (event.button != null && event.button !== 0) return;
      isDragging = true;
      hasDragged = false;
      dragStartX = event.clientX || 0;
      dragStartScrollLeft = wrapper.scrollLeft;
    });
    wrapper.addEventListener('pointermove', (event) => {
      if (!isDragging) return;
      const currentX = event.clientX || dragStartX;
      if (!hasDragged && Math.abs(currentX - dragStartX) > 3) {
        hasDragged = true;
        wrapper.classList.add('is-dragging');
        wrapper.setPointerCapture?.(event.pointerId);
      }
      if (!hasDragged) return;
      wrapper.scrollLeft = dragStartScrollLeft - (currentX - dragStartX);
      event.preventDefault();
    });
    const endDrag = (event) => {
      if (!isDragging) return;
      isDragging = false;
      wrapper.classList.remove('is-dragging');
      wrapper.releasePointerCapture?.(event.pointerId);
      if (!hasDragged) return;
      suppressClickUntil = Date.now() + 350;
      slideTo(getClosestIndex());
    };
    wrapper.addEventListener('pointerup', endDrag);
    wrapper.addEventListener('pointercancel', endDrag);
    wrapper.addEventListener(
      'click',
      (event) => {
        if (Date.now() > suppressClickUntil) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true,
    );

    gallery._personalizedUpsellSyncGallery = () => syncTo(activeIndex, { scrollThumb: false });
    gallery._personalizedUpsellGoToGalleryIndex = slideTo;
    syncTo(0, { scrollThumb: false });
  };

  const renderCompactCanvas = (canvas, sourceImg, form) => {
    if (!canvas || !sourceImg) return;

    const configScript =
      sourceImg.closest('[data-ps-gallery], .ps-card-preview, .ps-card-drawer')?.querySelector('.jp2d-compact-config') ||
      sourceImg.parentElement?.querySelector('.jp2d-compact-config');
    let compactData = null;
    if (configScript) {
      try {
        compactData = JSON.parse(configScript.textContent || '{}');
      } catch (error) {}
    }

    const draw = () => {
      const variantId = form?.querySelector('input[name="id"]')?.value;
      const scene = compactData && ((variantId && compactData[variantId]) || compactData[Object.keys(compactData)[0]]);
      const compactView = scene?.compactView;
      const ctx = canvas.getContext('2d');
      if (!ctx || !sourceImg.naturalWidth) return;

      if (!compactView) {
        canvas.width = sourceImg.naturalWidth || 400;
        canvas.height = sourceImg.naturalHeight || 400;
        ctx.drawImage(sourceImg, 0, 0, canvas.width, canvas.height);
        return;
      }

      const srcX = (compactView.x / 100) * sourceImg.naturalWidth;
      const srcY = (compactView.y / 100) * sourceImg.naturalHeight;
      const srcW = (compactView.width / 100) * sourceImg.naturalWidth;
      const srcH = (compactView.height / 100) * sourceImg.naturalHeight;
      const rotation = compactView.rotation || 0;
      const isRotated90 = rotation === 90 || rotation === 270;
      const outW = isRotated90 ? Math.round(srcH) : Math.round(srcW);
      const outH = isRotated90 ? Math.round(srcW) : Math.round(srcH);

      canvas.width = outW;
      canvas.height = outH;
      ctx.save();
      ctx.translate(outW / 2, outH / 2);
      ctx.rotate((rotation * Math.PI) / 180);
      ctx.drawImage(sourceImg, srcX, srcY, srcW, srcH, -(isRotated90 ? outH : outW) / 2, -(isRotated90 ? outW : outH) / 2, isRotated90 ? outH : outW, isRotated90 ? outW : outH);
      ctx.restore();
    };
    const drawWhenReady = () => {
      if (sourceImg.complete && sourceImg.naturalWidth > 0) {
        draw();
      } else {
        sourceImg.addEventListener('load', draw, { once: true });
      }
    };

    drawWhenReady();
    sourceImg.addEventListener('load', draw);

    new MutationObserver(drawWhenReady).observe(sourceImg, { attributes: true, attributeFilter: ['src'] });
  };

  const wirePreview = (drawer) => {
    drawer.querySelectorAll('[data-ps-gallery]').forEach(wireGallery);

    drawer.querySelectorAll('[data-ps-compact-preview]').forEach((preview) => {
      if (preview.dataset.personalizedUpsellPreviewWired === 'true') return;
      preview.dataset.personalizedUpsellPreviewWired = 'true';
      const canvas = preview.querySelector('.jp2d-compact-canvas');
      const sourceImg = preview.querySelector('.jp2d-preview-img');
      const formId = preview.dataset.psPreviewFormId || sourceImg?.dataset.formId;
      const form = formId ? document.getElementById(formId) : drawer;
      renderCompactCanvas(canvas, sourceImg, form);
      preview.addEventListener('click', () => openPreviewOverlay(preview.dataset.psPreviewOverlayId, sourceImg));
    });

    drawer.querySelectorAll('[data-ps-gallery-zoom]').forEach((trigger) => {
      if (trigger.dataset.personalizedUpsellZoomWired === 'true') return;
      trigger.dataset.personalizedUpsellZoomWired = 'true';
      const sourceImg = trigger.querySelector('img') || trigger;
      trigger.addEventListener('click', () => openPreviewOverlay(trigger.dataset.psPreviewOverlayId, sourceImg));
    });

    drawer.querySelectorAll('[data-ps-upsell-preview-button]').forEach((button) => {
      if (button.dataset.personalizedUpsellPreviewButtonWired === 'true') return;
      button.dataset.personalizedUpsellPreviewButtonWired = 'true';
      button.addEventListener('click', () => {
        const gallery = drawer.querySelector('[data-ps-gallery]');
        const preview = drawer.querySelector('[data-ps-gallery-zoom], [data-ps-compact-preview]');
        if (gallery?._personalizedUpsellGoToGalleryIndex) gallery._personalizedUpsellGoToGalleryIndex(0, 300);
        const body = drawer.querySelector('.ps-card-drawer__body');
        const target = gallery || preview;
        if (body && target) {
          const top = target.getBoundingClientRect().top - body.getBoundingClientRect().top + body.scrollTop;
          body.scrollTo({ top: Math.max(0, top - 4), behavior: 'smooth' });
        }
      });
    });
  };

  const moveOverlayToBody = (overlay) => {
    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
  };

  const closePreviewOverlay = (overlay) => {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    const returnTo = overlay._personalizedUpsellReturnFocus;
    overlay._personalizedUpsellReturnFocus = null;
    if (returnTo && typeof returnTo.focus === 'function' && document.contains(returnTo)) returnTo.focus();
  };

  const focusOverlayClose = (overlay) => {
    overlay.querySelector('.ps-preview-overlay__close')?.focus();
  };

  const getGalleryItems = (sourceImg) => {
    const gallery = sourceImg?.closest?.('[data-ps-gallery]');
    if (!gallery) return [];

    return [...gallery.querySelectorAll('.ps-card-gallery__slide')]
      .map((slide) => {
        const img = slide.querySelector('img.jp2d-preview-img, img.ps-card-gallery__img, img');
        const src = img?.getAttribute('data-ps-gallery-full-src') || img?.getAttribute('src');
        if (!img || !src) return null;
        return {
          src,
          alt: img.getAttribute('alt') || '',
          sourceImg: img,
        };
      })
      .filter(Boolean);
  };

  const ensureOverlayGallery = (overlay) => {
    const content = overlay.querySelector('.ps-preview-overlay__content');
    if (!content) return null;
    let gallery = content.querySelector('[data-ps-overlay-gallery]');
    if (gallery) return gallery;

    gallery = document.createElement('div');
    gallery.className = 'ps-preview-overlay__gallery';
    gallery.setAttribute('data-ps-overlay-gallery', '');
    gallery.innerHTML =
      '<div class="ps-preview-overlay__track" data-ps-overlay-track></div><div class="ps-preview-overlay__thumbs" data-ps-overlay-thumbs></div>';
    content.appendChild(gallery);
    return gallery;
  };

  const openPreviewOverlayGallery = (overlay, sourceImg, items) => {
    const content = overlay.querySelector('.ps-preview-overlay__content');
    const gallery = ensureOverlayGallery(overlay);
    const track = gallery?.querySelector('[data-ps-overlay-track]');
    const thumbs = gallery?.querySelector('[data-ps-overlay-thumbs]');
    if (!content || !gallery || !track || !thumbs) return false;

    const activeIndex = Math.max(
      0,
      items.findIndex((item) => item.sourceImg === sourceImg),
    );
    let overlayActiveIndex = activeIndex;
    track.innerHTML = '';
    thumbs.innerHTML = '';

    items.forEach((item, index) => {
      const slide = document.createElement('div');
      slide.className = 'ps-preview-overlay__slide';
      slide.setAttribute('role', 'group');
      slide.setAttribute('aria-label', `${index + 1} / ${items.length}`);

      const img = document.createElement('img');
      img.src = item.src;
      img.alt = item.alt;
      img.loading = index === activeIndex ? 'eager' : 'lazy';
      img.draggable = false;
      slide.appendChild(img);
      track.appendChild(slide);

      const thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = `ps-preview-overlay__thumb${index === activeIndex ? ' is-active' : ''}`;
      thumb.setAttribute('aria-label', `${index + 1} / ${items.length}`);
      if (index === activeIndex) thumb.setAttribute('aria-current', 'true');

      const thumbImg = document.createElement('img');
      thumbImg.src = item.sourceImg?.getAttribute('src') || item.src;
      thumbImg.alt = item.alt;
      thumb.appendChild(thumbImg);
      thumb.addEventListener('click', () => {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
      thumbs.appendChild(thumb);
    });

    let scrollFrame = null;
    const getClosestIndex = () => {
      const trackLeft = track.getBoundingClientRect().left;
      const slides = [...track.querySelectorAll('.ps-preview-overlay__slide')];
      return slides.reduce(
        (closest, slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          return distance < closest.distance ? { index, distance } : closest;
        },
        { index: overlayActiveIndex, distance: Infinity },
      ).index;
    };
    const syncThumbs = () => {
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        const nextIndex = getClosestIndex();
        overlayActiveIndex = nextIndex;
        [...thumbs.querySelectorAll('.ps-preview-overlay__thumb')].forEach((thumb, index) => {
          const isActive = index === nextIndex;
          thumb.classList.toggle('is-active', isActive);
          if (isActive) {
            thumb.setAttribute('aria-current', 'true');
            thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      });
    };

    track.onscroll = syncThumbs;
    let dragStartX = 0;
    let dragStartScrollLeft = 0;
    let isDragging = false;
    let hasDragged = false;
    let suppressClickUntil = 0;

    track.onpointerdown = (event) => {
      if (event.button != null && event.button !== 0) return;
      isDragging = true;
      hasDragged = false;
      dragStartX = event.clientX || 0;
      dragStartScrollLeft = track.scrollLeft;
    };
    track.onpointermove = (event) => {
      if (!isDragging) return;
      const currentX = event.clientX || dragStartX;
      if (!hasDragged && Math.abs(currentX - dragStartX) > 3) {
        hasDragged = true;
        track.classList.add('is-dragging');
        track.setPointerCapture?.(event.pointerId);
      }
      if (!hasDragged) return;
      track.scrollLeft = dragStartScrollLeft - (currentX - dragStartX);
      event.preventDefault();
    };
    track.onpointerup = (event) => {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      track.releasePointerCapture?.(event.pointerId);
      if (!hasDragged) return;
      suppressClickUntil = Date.now() + 350;
      const slide = track.querySelectorAll('.ps-preview-overlay__slide')[getClosestIndex()];
      slide?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      syncThumbs();
    };
    track.onpointercancel = track.onpointerup;
    track.onclick = (event) => {
      if (Date.now() <= suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (event.target?.closest?.('img')) return;
      closePreviewOverlay(overlay);
    };
    thumbs.onclick = (event) => {
      if (event.target?.closest?.('.ps-preview-overlay__thumb')) return;
      closePreviewOverlay(overlay);
    };

    content.classList.add('has-gallery');
    overlay.querySelector('.ps-preview-overlay__img')?.setAttribute('hidden', '');
    gallery.removeAttribute('hidden');
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');

    requestAnimationFrame(() => {
      const activeSlide = track.querySelectorAll('.ps-preview-overlay__slide')[activeIndex];
      activeSlide?.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'start' });
      syncThumbs();
    });

    return true;
  };

  const openPreviewOverlay = (overlayId, sourceImg) => {
    const overlay = overlayId ? document.getElementById(overlayId) : null;
    if (!overlay || !sourceImg) return;
    moveOverlayToBody(overlay);
    overlay._personalizedUpsellReturnFocus = document.activeElement;

    const items = getGalleryItems(sourceImg);
    if (items.length > 1 && openPreviewOverlayGallery(overlay, sourceImg, items)) {
      focusOverlayClose(overlay);
      return;
    }

    const content = overlay.querySelector('.ps-preview-overlay__content');
    content?.classList.remove('has-gallery');
    content?.querySelector('[data-ps-overlay-gallery]')?.setAttribute('hidden', '');

    const img = overlay.querySelector('.ps-preview-overlay__img');
    const src = sourceImg.getAttribute('data-ps-gallery-full-src') || sourceImg.getAttribute('src');
    if (img && src) {
      img.removeAttribute('hidden');
      img.setAttribute('src', src);
    }
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    focusOverlayClose(overlay);
  };

  const wireOverlay = (overlay) => {
    if (!overlay || overlay.dataset.personalizedUpsellOverlayWired === 'true') return;
    moveOverlayToBody(overlay);
    overlay.dataset.personalizedUpsellOverlayWired = 'true';
    const close = () => closePreviewOverlay(overlay);
    overlay.querySelector('.ps-preview-overlay__backdrop')?.addEventListener('click', close);
    overlay.querySelector('.ps-preview-overlay__close')?.addEventListener('click', close);
    overlay.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
        event.preventDefault();
        close();
      }
    });
  };

  const getSelectedUpsells = () => {
    return [...document.querySelectorAll('[data-personalized-upsell-block] [data-ps-personalized-upsell]')]
      .filter((card) => card.querySelector('.ps-upsell-checkbox')?.checked)
      .map((card) => {
        const drawer = getDrawer(card);
        const containerId = card.dataset.psCardFormId;
        const container = containerId ? document.getElementById(containerId) : drawer;
        const properties = {};
        const propertyScope = drawer || container;
        propertyScope
          ?.querySelectorAll(
            'input[name^="properties["]:not(:disabled), select[name^="properties["]:not(:disabled), textarea[name^="properties["]:not(:disabled)',
          )
          .forEach((field) => {
            if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) return;
            const match = field.name.match(/^properties\[(.+)\]$/);
            if (match?.[1] && field.value) properties[match[1]] = field.value;
          });

        return {
          variantId: container?.querySelector('[data-ps-card-variant-id-input]')?.value || card.dataset.upsellVariantId,
          price: parseInt(card.dataset.upsellPrice || '0', 10),
          nested: card.dataset.upsellNested !== 'false',
          properties,
        };
      })
      .filter((upsell) => upsell.variantId);
  };

  const updateSelectedPriceDelta = () => {
    const priceContainer = document.querySelector('[id^="price-"]');
    const priceElement = priceContainer?.querySelector('.price-regular .price');
    if (!priceElement) return;

    const selectedTotal = getSelectedUpsells().reduce((sum, upsell) => sum + (upsell.price || 0), 0);
    if (!priceElement.dataset.personalizedUpsellOriginalHtml) {
      priceElement.dataset.personalizedUpsellOriginalHtml = priceElement.innerHTML;
      const text = priceElement.textContent.trim().replace(/[^0-9.,]/g, '').replace(',', '.');
      const parsed = parseFloat(text);
      priceElement.dataset.personalizedUpsellOriginalPrice = Number.isNaN(parsed) ? '0' : String(Math.round(parsed * 100));
    }

    if (selectedTotal > 0) {
      const basePrice = parseInt(priceElement.dataset.personalizedUpsellOriginalPrice || '0', 10);
      priceElement.innerHTML = formatMoney(basePrice + selectedTotal);
    } else {
      priceElement.innerHTML = priceElement.dataset.personalizedUpsellOriginalHtml;
      delete priceElement.dataset.personalizedUpsellOriginalHtml;
      delete priceElement.dataset.personalizedUpsellOriginalPrice;
    }
  };

  const wireCard = (card) => {
    if (card.dataset.personalizedUpsellWired === 'true') return;
    card.dataset.personalizedUpsellWired = 'true';

    const drawer = getDrawer(card);
    const needsDrawer = card.dataset.personalizedUpsellNeedsDrawer === 'true';
    const checkbox = card.querySelector('.ps-upsell-checkbox');
    const isFathersDayLandingPage = !!card.closest('.lp-fathers-day');

    if (drawer) {
      drawer.classList.add('personalization-steps-block');
      if (isFathersDayLandingPage) document.body.classList.add('lp-fathers-day');
      wireVariantOptions(card, drawer);
      wirePreview(drawer);
      wireOverlay(document.getElementById(drawer.querySelector('[data-ps-preview-overlay-id]')?.dataset.psPreviewOverlayId));
      document.querySelectorAll('.ps-preview-overlay').forEach(wireOverlay);
    }

    card.addEventListener('click', (event) => {
      if (event.target.closest('[data-ps-upsell-more]')) return;
      const clickedCheckbox = event.target === checkbox;

      if (clickedCheckbox && !needsDrawer) {
        return;
      }

      event.preventDefault();
      if (drawer?.classList.contains('is-open')) {
        closeDrawer(drawer);
      } else if (clickedCheckbox && needsDrawer) {
        if (checkbox.checked) {
          checkbox.checked = false;
          openDrawer(drawer);
        } else {
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else if (!needsDrawer) {
        if (checkbox) {
          checkbox.checked = !checkbox.checked;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else if (checkbox?.checked) {
        checkbox.checked = false;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        openDrawer(drawer);
      }
    });

    if (drawer) {
      drawer.querySelectorAll('[data-ps-drawer-confirm]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!validateDrawer(card, drawer)) return;
          if (checkbox) {
            checkbox.checked = true;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
          closeDrawer(drawer);
        });
      });

      drawer.querySelectorAll('[data-ps-drawer-cancel]').forEach((button) => {
        button.addEventListener('click', () => closeDrawer(drawer));
      });
    }

    checkbox?.addEventListener('change', updateSelectedPriceDelta);

    const desc = card.querySelector('[data-ps-upsell-desc]');
    const moreBtn = card.querySelector('[data-ps-upsell-more]');
    if (desc && moreBtn) {
      moreBtn.hidden = desc.scrollHeight <= desc.clientHeight + 1;
      moreBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        card.classList.toggle('is-expanded');
        moreBtn.hidden = true;
      });
    }
  };

  const hideUpsellsAlreadyInCart = async () => {
    const cardsToCheck = document.querySelectorAll(
      '[data-personalized-upsell-block] [data-upsell-card][data-upsell-hide-if-in-cart="true"]',
    );
    if (!cardsToCheck.length) return;

    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      const variantIds = new Set((cart.items || []).map((item) => item.variant_id));
      const productIds = new Set((cart.items || []).map((item) => item.product_id));

      cardsToCheck.forEach((card) => {
        const variantId = parseInt(card.dataset.upsellVariantId, 10);
        const productId = parseInt(card.dataset.upsellProductId, 10);
        if (variantIds.has(variantId) || productIds.has(productId)) {
          card.hidden = true;
          const checkbox = card.querySelector('.ps-upsell-checkbox');
          if (checkbox) checkbox.checked = false;
        }
      });
    } catch (error) {}
  };

  const interceptAddToCart = () => {
    if (window.personalizedUpsellFetchIntercepted) return;
    window.personalizedUpsellFetchIntercepted = true;
    const originalFetch = window.fetch;

    window.fetch = function (url, config) {
      if (typeof url === 'string' && url.includes('/cart/add') && config?.body instanceof FormData) {
        const upsells = getSelectedUpsells();
        if (upsells.length) {
          const formData = config.body;
          const mainProductId = formData.get('id');
          const quantity = formData.get('quantity') || 1;
          const mainItem = {
            id: parseInt(mainProductId, 10),
            quantity: parseInt(quantity, 10),
          };
          const mainProperties = {};
          formData.forEach((value, key) => {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match?.[1] && value) mainProperties[match[1]] = value;
          });
          if (Object.keys(mainProperties).length) mainItem.properties = mainProperties;

          const items = [mainItem];
          upsells.forEach((upsell) => {
            const item = {
              id: parseInt(upsell.variantId, 10),
              quantity: parseInt(quantity, 10),
            };
            const properties = { ...upsell.properties, _channel: 'product_page', _upsell: 'true' };
            if (upsell.nested && mainProductId) {
              item.parent_id = parseInt(mainProductId, 10);
              properties._for_variant_id = String(mainProductId);
            }
            item.properties = properties;
            items.push(item);
          });

          const requestBody = { items };
          const sections = formData.get('sections');
          const sectionsUrl = formData.get('sections_url');
          if (sections) requestBody.sections = sections;
          if (sectionsUrl) requestBody.sections_url = sectionsUrl;

          return originalFetch(url, {
            ...config,
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(requestBody),
          });
        }
      }

      return originalFetch.apply(window, arguments);
    };
  };

  const init = () => {
    document.querySelectorAll('[data-personalized-upsell-block] [data-ps-personalized-upsell]').forEach(wireCard);
    hideUpsellsAlreadyInCart();
    interceptAddToCart();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
